import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import UpdateWidgetMutation from '../../../../mutations/UpdateWidgetMutation';
import WidgetForm from '../../../../components/WidgetForm';

function getStateFromProps(props) {
  const widgetConfig = props.widget.config || {};
  return {
    widget: {
      name: props.widget.name,
      type: props.widget.type,
      config: {
        filterComments: widgetConfig.filterComments,
        sliceByQuestion: widgetConfig.sliceByQuestion,
        aggregateQuestions: widgetConfig.aggregateQuestions,
        subtitle: widgetConfig.subtitle,
        ignoreDateFilter: widgetConfig.ignoreDateFilter,
        showLastXMonths: widgetConfig.showLastXMonths,
        hideHeader: widgetConfig.hideHeader,
        hideCommentTime: widgetConfig.hideCommentTime,
        staticYAxisScale: widgetConfig.staticYAxisScale,
        commentExtraColumns: widgetConfig.commentExtraColumns,
        question: widgetConfig.question && widgetConfig.question.mongoId,
      },
    },
    allowSave: false,
  };
}

class EditWidgetDialog extends Component {
  constructor(props) {
    super(props);
    this.state = getStateFromProps(props);
  }

  handleFormChange = (widget, allowSave) => {
    this.setState({widget, allowSave});
  };

  save = () => {
    UpdateWidgetMutation.commit(Object.assign({}, this.state.widget, {widgetId: this.props.widget.id}));
    this.props.onClose();
  };

  cancel = () => {
    this.props.onClose();
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open !== this.props.open) {
      this.setState(getStateFromProps(this.props));
    }
  }

  render() {
    const dialogActions = [
      <FlatButton 
        label="Cancel"
        onTouchTap={this.cancel}
      />,
      <RaisedButton 
        label="Save"
        primary={true}
        onTouchTap={this.save}
        disabled={!this.state.allowSave}
      />,
    ];
    return (
      <Dialog
        title="Edit widget"
        open={this.props.open}
        autoScrollBodyContent={true}
        actions={dialogActions}
        onRequestClose={this.props.onClose}
      >
        <WidgetForm
          surveys={this.props.surveys}
          widget={this.state.widget}
          onChange={this.handleFormChange}
        />
      </Dialog>
    );
  }
}

export default createFragmentContainer(
  EditWidgetDialog,
  graphql`
    fragment EditWidgetDialog_widget on Widget {
      id
      name
      type
      config {
        filterComments
        sliceByQuestion
        aggregateQuestions
        subtitle
        ignoreDateFilter
        showLastXMonths
        hideHeader
        hideCommentTime
        staticYAxisScale
        commentExtraColumns {
          title
          questionId
        }
        question {
          mongoId
        }
      }
    }
    fragment EditWidgetDialog_surveys on SurveyConnection {
      ...WidgetForm_surveys
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/components/EditWidgetDialog/EditWidgetDialog.js